var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/clipboard/~/good-listener/~/delegate/~/closest/index.js
 ** module id = 113
 ** module chunks = 0
 **/